import { apiRequest } from "@/shared/api/client";

export interface MediaServerClient {
  name: string;
  type?: string;
}

export interface MediaServerLibrary {
  server?: string | null;
  id?: string | number | null;
  name?: string | null;
  type?: string | null;
  path?: string | string[] | null;
  image?: string | null;
  link?: string | null;
}

export interface MediaServerPlayItem {
  id?: string | number | null;
  title?: string | null;
  subtitle?: string | null;
  type?: string | null;
  image?: string | null;
  link?: string | null;
  percent?: number | null;
}

export function listMediaServers() {
  return apiRequest<MediaServerClient[]>("/api/v1/mediaserver/clients");
}

export function listLibraries(server: string) {
  const s = encodeURIComponent(server);
  return apiRequest<MediaServerLibrary[]>(
    `/api/v1/mediaserver/library?server=${s}`,
  );
}

export function listLatest(server: string, count = 20) {
  const s = encodeURIComponent(server);
  return apiRequest<MediaServerPlayItem[]>(
    `/api/v1/mediaserver/latest?server=${s}&count=${count}`,
  );
}

export function listPlaying(server: string, count = 12) {
  const s = encodeURIComponent(server);
  return apiRequest<MediaServerPlayItem[]>(
    `/api/v1/mediaserver/playing?server=${s}&count=${count}`,
  );
}
